module.exports = __webpack_public_path__ + "f4afd5de9883d137b23785ae32f49a8a.svg";